import { render, staticRenderFns } from "./avisosPortalAluno.vue?vue&type=template&id=7c615142&"
import script from "./avisosPortalAluno.vue?vue&type=script&lang=js&"
export * from "./avisosPortalAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports